import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { Typography } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import type { ImportPosting } from './importStatsMeta';

type ImportPostingLineProps = {
    posting: ImportPosting;
};

/**
 * What the import booked, in one line: the opening-stock entry (Dr
 * Inventory / Cr Opening balance equity, the stock's net value) behind a
 * lock, as the books keep it, or that nothing was posted when the stock
 * costs nothing. `data-posted` says which.
 */
export const ImportPostingLine: React.FC<ImportPostingLineProps> = ({
    posting,
}) => {
    const { t } = useTranslation('pages');

    return (
        <div
            className="flex items-start gap-2"
            data-posted={posting.posted}
            {...getNodeTestIdProp('catalog-import-result-posting')}
        >
            <Icon
                aria-hidden
                className="mt-0.5 size-4 shrink-0 text-muted"
                icon={
                    posting.posted
                        ? 'gravity-ui:lock'
                        : 'gravity-ui:circle-info'
                }
            />
            <Typography color="muted" type="body-sm">
                {posting.posted
                    ? t('catalogImport.result.posting.posted', {
                          amount: posting.amount,
                      })
                    : t('catalogImport.result.posting.none')}
            </Typography>
        </div>
    );
};
